module.exports = __webpack_public_path__ + "img/4-4.daf1c87c.jpg";